import React from "react";

class ItemFamilySelect extends React.Component {

    constructor(props) {
        super(props);

        this.default_value = 'Basic';
        if (props.value) {
            this.default_value = props.value;
        }

        this.state = {
            itemFamily: this.default_value
        };

        this.resetState = this.resetState.bind(this);
        this.onChangeItemFamily = this.onChangeItemFamily.bind(this);
    }

    componentDidMount() {
        const itemFamily = this.props.value || this.default_value;
        this.setState({ itemFamily });
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            const itemFamily = this.props.value;
            this.setState({ itemFamily });
        }
    }

    onChangeItemFamily(itemFamily) {
        this.setState({ itemFamily });

        const { name, onChange } = this.props;
        if (onChange) {
            onChange({ target: { name, value: itemFamily } });
        }
    }

    resetState() {
        this.setState({ itemFamily: this.default_value });
    }

    render() {
        const { itemFamily } = this.state;
        const { id, label, className } = this.props;

        const basicClassName = itemFamily === "Basic" ? `is-link` : '';
        const complementaryClassName = itemFamily === "Complementary" ? `is-link` : '';

        return (
            <React.Fragment>
                <label className="label">{label}</label>
                <div id={id} className="columns is-gapless">
                    <div className="column">
                        <button
                            type="button" className={`button ${className} is-fullwidth ${basicClassName}`}
                            onClick={() => this.onChangeItemFamily("Basic")}>Basic</button>
                    </div>
                    <div className="column">
                        <button
                            type="button" className={`button ${className} is-fullwidth ${complementaryClassName}`}
                            onClick={() => this.onChangeItemFamily("Complementary")}>Complementary</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ItemFamilySelect;
